import { ButtonDesignTokens } from '@primeuix/themes/types/button';

export const BUTTON_STYLES: ButtonDesignTokens = {
  root: {
    sm: {
      paddingY: '0.55rem',
    },
  },
  colorScheme: {
    light: {
      text: {
        primary: {
          hoverBackground: 'transparent',
          activeBackground: 'transparent',
        },
      },
    },
  },
};
